import React from "react";
import { PolicyPackage } from "../../interfaces/altair";
import { useOverlayPopupOpen } from "../../hooks/use-overlay-popup-open";
import "../shared/popup-card.scss";

interface PolicyConfirmationProps {
  visible: boolean;
  selectedPackage: PolicyPackage | null;
  onConfirm: () => void;
}

export const PolicyConfirmation: React.FC<PolicyConfirmationProps> = ({
  visible,
  selectedPackage,
  onConfirm,
}) => {
  useOverlayPopupOpen(visible && !!selectedPackage);
  if (!visible || !selectedPackage) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-card">
        <h3 className="popup-title">تأكيد الباقة</h3>
        <p className="popup-subtitle">مراجعة الباقة المختارة قبل إرسال الطلب</p>
        <div className="popup-value-display">
          <div className="popup-value-display__row">
            <span>{selectedPackage.packageTypeAr} ({selectedPackage.packageTypeEn})</span>
            <span className="popup-value-display__row-value">
              {selectedPackage.totalpremium.toLocaleString("ar-EG")} جنيه
            </span>
          </div>
        </div>
        <button onClick={onConfirm} className="popup-btn-primary">
          تأكيد الباقة وإرسال لينك الدفع
        </button>
      </div>
    </div>
  );
};
